// Заглушка локализации. Lingui CLI (`pnpm lingui extract`) перезаписывает.
export const messages = {
  hello: 'Привет, мир',
}
